import * as React from 'react';
import Helmet from 'react-helmet-async';
import { renderRoutes } from '../../../util/route/render-routes';
import {inject} from 'mobx-react';
import {IInjectedProps} from '../../../interface/component/injected-props.interface';
import {GoogleTagManager} from '../../../google-tag-manager';

@inject('state', 'location')
export class IndexPage extends React.Component<{ route: any } & IInjectedProps> {
  componentDidMount() {
    const state = this.props.state;
    // Give enough time to the googletagmanager script to initialize
    setTimeout(() => {
      GoogleTagManager.pushCustomPageViewEvent(state, '200');
    }, 500);
  }

  render() {
    return <>
      <Helmet>
        <title>This is a frontend page index</title>
      </Helmet>
      {renderRoutes(this.props.route.routes)}
    </>;
  }
}
